import { BaseItem } from 'containers/Base/BaseItem';

export type EntityListItem = BaseItem;

export interface BaseEntityItem {
  id: string;
  name: string;
  code: string;
}

export interface BaseEntityItemWrapper<T> extends BaseEntityItem {
  source: T;
}

export enum ListEntityItemType {
  Entity = 'Entity',
  AddEntity = 'AddEntity',
}

export interface EntityItem<T extends BaseEntityItem> extends EntityListItem {
  type: ListEntityItemType.Entity;
  entity: T;
}

export interface AddEntityItem extends EntityListItem {
  type: ListEntityItemType.AddEntity;
}

export function createAddEntityItem(): AddEntityItem {
  return {
    id: 'add_entity_item',
    type: ListEntityItemType.AddEntity,
  };
}

export function createEntityItem<T extends BaseEntityItem>(
  id: string,
  entity: T
): EntityItem<T> {
  return {
    id,
    type: ListEntityItemType.Entity,
    entity,
  };
}
